module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"exceed":"У вас закончились просмотры откликов","variants":"Варианты","leftDays":"Осталось дней","wait":"Подождать до начала следующего отчётного периода","choose":"Выбрать тариф","upgrade":"Перейти на более высокий тариф и посмотреть новые отклики прямо сейчас."}}')
  delete Component.options._Ctor
}
